import React, { useEffect, useState } from 'react';
import client from '../../api/client';
import Navbar from '../../components/Navbar';

export default function DemoQueue() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [marking, setMarking] = useState({});

  useEffect(() => {
    client.get('/api/admin/demo-requests/')
      .then((res) => setRequests(res.data))
      .finally(() => setLoading(false));
  }, []);

  async function handleMarkContacted(id) {
    setMarking((m) => ({ ...m, [id]: true }));
    try {
      await client.post(`/api/admin/demo-requests/${id}/mark-contacted/`);
      setRequests((prev) =>
        prev.map((r) => (r.id === id ? { ...r, contacted: true } : r))
      );
    } catch {
      alert('Failed to update status.');
    } finally {
      setMarking((m) => ({ ...m, [id]: false }));
    }
  }

  const uncontacted = requests.filter((r) => !r.contacted);
  const contacted = requests.filter((r) => r.contacted);
  const sorted = [...uncontacted, ...contacted];

  return (
    <div style={s.page}>
      <Navbar />
      <div style={s.content}>
        <div style={s.header}>
          <h1 style={s.title}>Demo Requests</h1>
          {!loading && (
            <span style={s.badge}>{uncontacted.length} pending</span>
          )}
        </div>

        {loading && <p style={s.hint}>Loading…</p>}
        {!loading && requests.length === 0 && (
          <p style={s.hint}>No demo requests yet.</p>
        )}

        {!loading && sorted.length > 0 && (
          <div style={s.tableWrap}>
            <table style={s.table}>
              <thead>
                <tr>
                  {['Name', 'Email', 'Type', 'Budget', 'Description', 'Date', 'Status', ''].map((h) => (
                    <th key={h} style={s.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {sorted.map((r) => (
                  <tr key={r.id} style={r.contacted ? s.rowContacted : s.row}>
                    <td style={s.td}>{r.name}</td>
                    <td style={s.td}>{r.email || '—'}</td>
                    <td style={s.td}>
                      <span style={s.typeTag}>{r.user_type}</span>
                    </td>
                    <td style={s.td}>{r.budget}</td>
                    <td style={{ ...s.td, ...s.tdDesc }}>{r.description}</td>
                    <td style={s.td}>{new Date(r.created_at).toLocaleDateString()}</td>
                    <td style={s.td}>
                      {r.contacted ? (
                        <span style={s.statusContacted}>Contacted</span>
                      ) : (
                        <span style={s.statusPending}>Not Contacted</span>
                      )}
                    </td>
                    <td style={s.td}>
                      {!r.contacted && (
                        <button
                          style={marking[r.id] ? s.markBtnDisabled : s.markBtn}
                          disabled={marking[r.id]}
                          onClick={() => handleMarkContacted(r.id)}
                        >
                          {marking[r.id] ? '…' : 'Mark Contacted'}
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', background: '#000', fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif", color: '#f0f0f0' },
  content: { padding: '2rem', maxWidth: '1200px', margin: '0 auto' },
  header: { display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' },
  title: { margin: 0, fontSize: '1.5rem', fontWeight: 800, color: '#fff', letterSpacing: '-0.01em' },
  badge: {
    background: '#000',
    color: '#fff',
    fontSize: '0.75rem',
    fontWeight: 700,
    padding: '0.2rem 0.65rem',
    letterSpacing: '0.06em',
  },
  hint: { color: '#888', fontSize: '0.9rem' },
  tableWrap: { overflowX: 'auto' },
  table: { width: '100%', borderCollapse: 'collapse', background: '#000', border: '1px solid #333' },
  th: {
    textAlign: 'left',
    padding: '0.75rem 1rem',
    background: '#000',
    color: '#fff',
    fontSize: '0.75rem',
    fontWeight: 700,
    letterSpacing: '0.07em',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
  row: { borderBottom: '1px solid #222' },
  rowContacted: { borderBottom: '1px solid #222', opacity: 0.55 },
  td: { padding: '0.75rem 1rem', fontSize: '0.88rem', color: '#ccc', verticalAlign: 'top' },
  tdDesc: { maxWidth: '260px', whiteSpace: 'pre-wrap', wordBreak: 'break-word' },
  typeTag: {
    display: 'inline-block',
    padding: '0.15rem 0.5rem',
    border: '1px solid #555',
    fontSize: '0.75rem',
    fontWeight: 600,
    textTransform: 'capitalize',
    color: '#bbb',
  },
  statusPending: { fontSize: '0.8rem', fontWeight: 600, color: '#555' },
  statusContacted: { fontSize: '0.8rem', fontWeight: 700, color: '#888' },
  markBtn: {
    background: '#000',
    color: '#fff',
    border: 'none',
    padding: '0.35rem 0.85rem',
    fontSize: '0.78rem',
    fontWeight: 600,
    cursor: 'pointer',
    letterSpacing: '0.04em',
    whiteSpace: 'nowrap',
  },
  markBtnDisabled: {
    background: '#999',
    color: '#fff',
    border: 'none',
    padding: '0.35rem 0.85rem',
    fontSize: '0.78rem',
    fontWeight: 600,
    cursor: 'not-allowed',
    letterSpacing: '0.04em',
    whiteSpace: 'nowrap',
  },
};
